import PrizeLandingPage from 'components/prize-landing-pages/PrizeLandingPage';
import MainLayout from 'components/layout/MainLayout';
import { ASSET_PREFIX } from 'utils/constants';
import GreenPageSection from 'components/GreenPageSection';
import Subheading from 'components/Subheading';
import RoundedButton from 'components/RoundedButton';
import ImageWithContentSection from 'components/prize-landing-pages/ImageWithContentSection';
import React, { useState } from 'react';
import { scrollToSection } from 'utils/common';
import WinnerContentSection from 'components/prize-landing-pages/WinnerContentSection';
import { NextSeo } from 'next-seo';
import GenericModal from 'components/GenericModal';
import HowItWorksAndChoosePlanSection
  from 'components/prize-landing-pages/HowItWorksAndChoosePlanSection';

const WinACruiseAroundTheWorld = () => {
  const imageDirectory = `${ASSET_PREFIX}/images/prize-landing-pages/win-a-cruise-around-the-world`;

  const [showFullItinerary, setShowFullItinerary] = useState(false);

  const handleScrollToEntryMethodCards = () => {
    scrollToSection('#howItWorksAndChoosePlanSection');
  };

  return (
    <MainLayout paddedMaxWidthContainer={false}>
      <NextSeo
        title="DAYMADE | Win A Cruise Around The World Worth £100k"
        description="Enter our weekly draw for the chance to win a 180-day cruise around the world for 2 PLUS up to £15k in spending money!"
        url="https://www.daymade.co.uk/prizes/details/win-around-the-world-cruise"
        openGraph={{
          title: 'DAYMADE | Win A Cruise Around The World Worth £100k',
          description: 'Enter our weekly draw for the chance to win a 180-day cruise around the world for 2 PLUS up to £15k in spending money!',
        }}
      />

      <div id="top-of-page" />

      <PrizeLandingPage>
        <img
          src={`${imageDirectory}/hero.png`}
          className='hero'
          alt="Couple taking selfie in-front of large cruise ship"
        />

        <GreenPageSection additionalClassName='pageTitleGreenSectionContainer' style={{ fontSize: '0.4em' }}>
          <Subheading Tag='h1' className='pageTitle'>
            Win A Cruise Around The World<br />
            <span style={{ fontSize: '2.4em', display: 'block' }}>
              Worth&nbsp;<strong>£100k</strong>
            </span>
          </Subheading>
          <p>
            Enter our weekly draw for the chance to win a 180-day cruise around the world for 2 PLUS up to £15k in spending money!
          </p>
          <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
            Enter Now
          </RoundedButton>
          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', margin: '3em 1em 0', width: '100%', maxWidth: 450 }}>
            <a href='https://uk.trustpilot.com/review/daymade.co.uk' target='_blank' style={{ margin: '0 0 2em 0', width: '35%' }}>
              <img src={`${ASSET_PREFIX}/images/play-free-lp/trustpilot-logo-grey.svg`} style={{ width: '100%' }} />
            </a>
            <a href='https://www.veritree.com/' target='_blank' style={{ margin: '0 0 2em 0', width: '50%', display: 'flex', alignItems: 'center', textAlign: 'left', wordBreak: 'break-word', whiteSpace: 'break-spaces' }}>
              <img src={`${ASSET_PREFIX}/images/veritree-logo-dark.svg`} style={{ width: '25%', marginRight: '0.5em' }} />
              Plant a tree with every purchase
            </a>
          </div>
        </GreenPageSection>

        <ImageWithContentSection
          subheadingText={<>Could You Be The Next <strong>Winner?</strong></>}
          imageSrc={`${imageDirectory}/secondary1.png`}
          imageAltText="grid of images showing large decks of cruise ship at night and bedroom cabins on-board"
        >
          <p>
            Take your best friend/partner/(grand)mother on the most unforgettable trip of your life: a cruise around the world in 180 days. Explore all the corners of the world aboard the Insignia cruise and tick off your entire bucket-list on this epic 6 months journey. From the historic sights of Mexico, to the star-gazing magic of Chile, to the deserted wonders of Antarctica, to wine-tasting in South Africa, to the white sandy beaches of the Seychelles, to a curry feast in India and getting lost in translation in Tokyo: you well and truly get to see it ALL!
          </p>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        { showFullItinerary && (
          <GenericModal onClose={() => setShowFullItinerary(false)}>
            <Subheading>
              Itinerary
            </Subheading>
            <ul style={{ textAlign: 'left' }}>
              <li>Jan 15 San Francisco, California</li>
              <li>Jan 16 Cruising the Pacific Ocean</li>
              <li>Jan 17 Ensenada, Mexico</li>
              <li>Jan 18 Cruising the Pacific Ocean</li>
              <li>Jan 19 Cruising the Pacific Ocean</li>
              <li>Jan 20 Manzanillo, Mexico</li>
              <li>Jan 21 Zihuatanejo/Ixtapa, Mexico</li>
              <li>Jan 22 Acapulco, Mexico</li>
              <li>Jan 23 Cruising the Pacific Ocean</li>
              <li>Jan 24 Puerto Chiapas, Mexico</li>
              <li>Jan 25 Puerto Quetzal, Guatemala</li>
              <li>Jan 26 Acajutla, El Salvador</li>
              <li>Jan 27 Cruising the Pacific Ocean</li>
              <li>Jan 28 Cruising the Pacific Ocean</li>
              <li>Jan 29 Manta, Ecuador</li>
              <li>Jan 30 Cruising the Pacific Ocean</li>
              <li>Jan 31 Salaverry, Peru</li>
              <li>Feb 1 Lima/Machu Picchu (Callao), Peru</li>
              <li>Feb 2 Pisco/Nazca Lines, Peru</li>
              <li>Feb 3 Cruising the Pacific Ocean</li>
              <li>Feb 4 Arica, Chile</li>
              <li>Feb 5 Iquique, Chile</li>
              <li>Feb 6 Cruising the Pacific Ocean</li>
              <li>Feb 7 Coquimbo, Chile</li>
              <li>Feb 8 Santiago de Chile (San Antonio), Chile</li>
              <li>Feb 9 Cruising the Pacific Ocean</li>
              <li>Feb 10 Puerto Montt, Chile</li>
              <li>Feb 11 Puerto Chacabuco, Chile</li>
              <li>Feb 12 "Cruising the Chilean Fjords</li>
              <li>• (Estero, Aysen & Strait of Magellan)"</li>
              <li>Feb 13 "Cruising the Chilean Fjords</li>
              <li>• (Estero, Aysen & Strait of Magellan)"</li>
              <li>Feb 14 Punta Arenas, Chile</li>
              <li>Feb 15 Ushuaia, Argentina</li>
              <li>Feb 16 Cruising the Drake Passage</li>
              <li>Feb 17 Cruising by Admiralty Bay, Antarctica</li>
              <li>Feb 18 Cruising by Paradise Bay, Antarctica</li>
              <li>Feb 19 Cruising by Half Moon Island, Antarctica</li>
              <li>Feb 20 Cruising the Drake Passage</li>
              <li>Feb 21 Port Stanley, Falkland Islands</li>
              <li>Feb 22 Cruising the Atlantic Ocean</li>
              <li>Feb 23 Cruising the Atlantic Ocean</li>
              <li>Feb 24 Punta del Este, Uruguay</li>
              <li>Feb 25 Buenos Aires, Argentina</li>
              <li>Feb 26 Buenos Aires, Argentina</li>
              <li>Feb 27 Montevideo, Uruguay</li>
              <li>Feb 28 Cruising the Atlantic Ocean</li>
              <li>Mar 1 Cruising the Atlantic Ocean</li>
              <li>Mar 2 São Paulo (Santos), Brazil</li>
              <li>Mar 3 Rio de Janeiro, Brazil</li>
              <li>Mar 4 Rio de Janeiro, Brazil</li>
              <li>Mar 5 Cabo Frio, Brazil</li>
              <li>Mar 6 Vitoria, Brazil</li>
              <li>Mar 7 Cruising the Atlantic Ocean</li>
              <li>Mar 8 Salvador, Brazil</li>
              <li>Mar 9 Maceió, Brazil</li>
              <li>Mar 10 Recife, Brazil</li>
              <li>Mar 11 Natal, Brazil</li>
              <li>Mar 12 Fortaleza, Brazil</li>
              <li>Mar 13 Cruising the Atlantic Ocean</li>
              <li>Mar 14 Cruising the Atlantic Ocean</li>
              <li>Mar 15 Cruising the Atlantic Ocean</li>
              <li>Mar 16 Mindelo (São Vicente), Cape Verde</li>
              <li>Mar 17 Cruising the Atlantic Ocean</li>
              <li>Mar 18 Dakar, Senegal</li>
              <li>Mar 19 Banjul, Gambia</li>
              <li>Mar 20 Cruising the Atlantic Ocean</li>
              <li>Mar 21 Cruising the Atlantic Ocean</li>
              <li>Mar 22 Abidjan, Ivory Coast</li>
              <li>Mar 23 Sekondi-Takoradi, Ghana</li>
              <li>Mar 24 Lomé, Togo</li>
              <li>Mar 25 Cotonou, Benin</li>
              <li>Mar 26 Cruising the Gulf of Guinea</li>
              <li>Mar 27 São Tomé, São Tomé & Principe</li>
              <li>Mar 28 Cruising the Atlantic Ocean</li>
              <li>Mar 29 Cruising the Atlantic Ocean</li>
              <li>Mar 30 Cruising the Atlantic Ocean</li>
              <li>Mar 31 Walvis Bay, Namibia</li>
              <li>Apr 1 Walvis Bay, Namibia</li>
              <li>Apr 2 Luderitz, Namibia</li>
              <li>Apr 3 Cruising the Atlantic Ocean</li>
              <li>Apr 4 Cape Town, South Africa</li>
              <li>Apr 5 Cape Town, South Africa</li>
              <li>Apr 6 Cape Town, South Africa</li>
              <li>Apr 7 Mossel Bay, South Africa</li>
              <li>Apr 8 Cruising the Indian Ocean</li>
              <li>Apr 9 Durban, South Africa</li>
              <li>Apr 10 Richards Bay, South Africa</li>
              <li>Apr 11 Maputo, Mozambique</li>
              <li>Apr 12 Cruising the Mozambique Channel</li>
              <li>Apr 13 Cruising the Mozambique Channel</li>
              <li>Apr 14 Mayotte, French Comoros</li>
              <li>Apr 15 Nosy Be, Madagascar</li>
              <li>Apr 16 Cruising the Indian Ocean</li>
              <li>Apr 17 Mahé, Seychelles</li>
              <li>Apr 18 Mahé, Seychelles</li>
              <li>Apr 18 La Digue, Seychelles</li>
              <li>Apr 19 Cruising the Indian Ocean</li>
              <li>Apr 20 Cruising the Arabian Sea</li>
              <li>Apr 21 Cruising the Arabian Sea</li>
              <li>Apr 22 Salalah, Oman</li>
              <li>Apr 23 Cruising the Arabian Sea</li>
              <li>Apr 24 Muscat, Oman</li>
              <li>Apr 25 Dubai, UAE</li>
              <li>Apr 26 Dubai, UAE</li>
              <li>Apr 27 Fujairah, UAE</li>
              <li>Apr 28 Cruising the Arabian Sea</li>
              <li>Apr 29 Cruising the Arabian Sea</li>
              <li>Apr 30 Mumbai, India</li>
              <li>May 1 Mumbai, India</li>
              <li>May 2 Goa (Mormugao), India</li>
              <li>May 3 Mangalore, India</li>
              <li>May 4 Cochin (Kochi), India</li>
              <li>May 5 Colombo, Sri Lanka</li>
              <li>May 6 Colombo, Sri Lanka</li>
              <li>May 7 Cruising the Bay of Bengal</li>
              <li>May 8 Cruising the Bay of Bengal</li>
              <li>May 9 Cruising the Andaman Sea</li>
              <li>May 10 Yangon, Myanmar</li>
              <li>May 11 Yangon, Myanmar</li>
              <li>May 12 Yangon, Myanmar</li>
              <li>May 13 Cruising the Andaman Sea</li>
              <li>May 14 Phuket, Thailand</li>
              <li>May 15 Penang, Malaysia</li>
              <li>May 16 Kuala Lumpur (Port Klang), Malaysia</li>
              <li>May 17 Singapore, Singapore</li>
              <li>May 18 Singapore, Singapore</li>
              <li>May 19 Cruising the Gulf of Thailand</li>
              <li>May 20 Ko Samui, Thailand</li>
              <li>May 21 Bangkok, Thailand</li>
              <li>May 22 Bangkok, Thailand</li>
              <li>May 23 Sihanoukville, Cambodia</li>
              <li>May 24 Cruising the South China Sea</li>
              <li>May 25 Saigon (Ho Chi Minh City), Vietnam</li>
              <li>May 26 Saigon (Ho Chi Minh City), Vietnam</li>
              <li>May 27 Nha Trang, Vietnam</li>
              <li>May 28 Hue (Chan May), Vietnam</li>
              <li>May 29 Hue (Chan May), Vietnam</li>
              <li>May 30 Hanoi (Ha Long Bay), Vietnam</li>
              <li>May 31 Cruising the South China Sea</li>
              <li>Jun 1 Hong Kong, China</li>
              <li>Jun 2 Hong Kong, China</li>
              <li>Jun 3 Xiamen, China</li>
              <li>Jun 4 Xiamen, China</li>
              <li>Jun 5 Cruising the East China Sea</li>
              <li>Jun 6 Shanghai, China</li>
              <li>Jun 7 Shanghai, China</li>
              <li>Jun 8 Cruising the Yellow Sea</li>
              <li>Jun 9 Beijing (Tianjin), China</li>
              <li>Jun 10 Beijing (Tianjin), China</li>
              <li>Jun 11 Dalian, China</li>
              <li>Jun 12 Cruising the Yellow Sea</li>
              <li>Jun 13 Moji, Japan</li>
              <li>Jun 14 Nagasaki, Japan</li>
              <li>Jun 15 Kagoshima, Japan</li>
              <li>Jun 16 Hiroshima, Japan</li>
              <li>Jun 17 Kyoto (Kobe), Japan</li>
              <li>Jun 18 Kyoto (Kobe), Japan</li>
              <li>Jun 19 Shimizu, Japan</li>
              <li>Jun 20 Tokyo, Japan</li>
              <li>Jun 21 Tokyo, Japan</li>
              <li>Jun 22 Cruising the Pacific Ocean</li>
              <li>Jun 23 Aomori, Japan</li>
              <li>Jun 24 Hakodate, Japan</li>
              <li>Jun 25 Cruising the Pacific Ocean</li>
              <li>Jun 26 Cruising the Pacific Ocean</li>
              <li>Jun 27 Petropavlovsk-Kamchatsky, Russia</li>
              <li>Jun 28 Cruising the Bering Sea</li>
              <li>Jun 28 Cross the International Date Line (Gain a day)</li>
              <li>Jun 29 Cruising the Bering Sea</li>
              <li>Jun 30 Dutch Harbor, Alaska</li>
              <li>Jul 1 Cruising the Pacific Ocean</li>
              <li>Jul 2 Kodiak, Alaska</li>
              <li>Jul 3 Seward, Alaska</li>
              <li>Jul 4 Cruising Hubbard Glacier</li>
              <li>Jul 5 Juneau, Alaska</li>
              <li>Jul 6 Sitka, Alaska</li>
              <li>Jul 7 Prince Rupert, British Columbia</li>
              <li>Jul 8 Cruising the Inside Passage</li>
              <li>Jul 9 Victoria, British Columbia</li>
              <li>Jul 10 Astoria, Oregon</li>
              <li>Jul 11 Cruising the Pacific Ocean</li>
              <li>Jul 12 San Francisco, California</li>
              <li>Jul 13 San Francisco, California</li>
            </ul>
          </GenericModal>
        )}

        <ImageWithContentSection
          subheadingText={<>What's <strong>Included?</strong></>}
          imageSrc={`${imageDirectory}/secondary2.png`}
          imageAltText="cruise ship anchored in small bay with pristine, unspoilt beaches"
          reverseDesktopDirection
        >
          <ul style={{ fontWeight: 600 }}>
            <li>
              Return flights for 2 from London
            </li>

            <li>
              Deluxe Ocean-view stateroom aboard the Oceania Insignia
            </li>

            <li>
              Onboard meals included
            </li>

            <li>
              Up to £15k in spending money if budget allows
            </li>

            <li>
              <button
                onClick={() => setShowFullItinerary(true)}
                style={{
                  background: 'transparent',
                  color: 'inherit',
                  padding: 0,
                  fontWeight: 'inherit',
                  textDecoration: 'underline',
                }}
              >
                See full itinerary
              </button>
            </li>
          </ul>

          <p style={{ color: '#666', fontStyle: 'italic', fontSize: '0.9em' }}>
            This prize is only available on the Cruise's set schedule. If the dates don't work for you, we'll find a similar 'Around the World' cruise.
          </p>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-1.png`}
          style={{
            width: '100%',
          }}
        />

        <WinnerContentSection
          onCtaClick={handleScrollToEntryMethodCards}
        />

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-2.png`}
          style={{
            width: '100%',
          }}
        />

        <HowItWorksAndChoosePlanSection />
      </PrizeLandingPage>

      <style jsx>
        {`
          :global(.pageTitleGreenSectionContainer .pageTitle) {
            font-size: 1.8em;
          }
          
          @media(max-width: 500px) {
            :global(.pageTitleGreenSectionContainer .pageTitle) {
              font-size: 1.2em;
            }
          }
        `}
      </style>
    </MainLayout>
  );
};

export default WinACruiseAroundTheWorld;
